import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import SplashScreen from '../screens/Splash/SplashScreen'

const PrivatePatientRoute = ({ redirectPath = '/login/patient' }) => {
    
  const {
    logged,
  } = useContext(GeneralContext)

  if (!logged) {
    return logged == null ? <SplashScreen/>: <Navigate to={redirectPath} replace />
  }

  return <Outlet/>
};

export default PrivatePatientRoute
